import React from 'react';
import { Reveal } from '../../ui/Reveal';
import { PillarVisual } from '../../ui/PillarVisuals';
import { pillars } from '../../../data/offer';
export function Pillars() {
  return <div className="mt-20" data-id="element-187" data-mp="3ae9810wple9g">
      <Reveal data-id="element-188" data-mp="3af0yjxbg8lsv">
        <h3 className="max-w-3xl text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-forest sm:text-3xl" data-id="element-189" data-mp="3adg7wis99n0a">
          Años de ciencia destilados en 6 pilares prácticos
        </h3>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-body" data-id="element-190" data-mp="30f0ci3m73rkz">
          Sin paja, sin relleno. Solo lo que tu cuerpo necesita para dejar de almacenar grasa y
          empezar a vibrar con energía.
        </p>
      </Reveal>

      <ol className="mt-10 space-y-4 sm:space-y-5" data-id="element-191" data-mp="2rhgdz2fpw9e2">
        {pillars.map((pillar, index) => <Reveal as="li" key={pillar.number} delay={Math.min(index, 4) * 0.05} className="list-none" data-id="element-192" data-mp="2weqaf21ixlbe" data-mpi={index}>
            <article className={['grid gap-5 overflow-hidden rounded-2xl bg-white p-5 shadow-card sm:gap-6 sm:p-8 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center lg:gap-10', pillar.core ? 'border-l-4 border-gold ring-1 ring-gold/40' : 'border-l-4 border-forest/15'].join(' ')} data-id="element-193" data-mp="pos264p0cdmo">
              <div className="min-w-0" data-id="element-194" data-mp="2acppsp248kna">
                <div className="flex items-start gap-3" data-id="element-195" data-mp="2o4w92k0kf7qy">
                  <span className={['flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-extrabold sm:h-10 sm:w-10 sm:text-sm', pillar.core ? 'bg-gold text-white' : 'bg-cream text-forest'].join(' ')} data-id="element-196" data-mp="2o4e48yzu7l7f">
                    {pillar.number}
                  </span>
                  <div className="min-w-0" data-id="element-197" data-mp="1rfolz7kasqkx">
                    <h4 className="text-[1.0625rem] font-bold leading-snug text-forest sm:text-xl" data-id="element-198" data-mp="1rgzol420bsag">
                      {pillar.title}
                    </h4>
                    {pillar.core && <span className="mt-2 inline-flex rounded-full bg-forest px-2.5 py-1 text-[0.6rem] font-bold uppercase tracking-[0.1em] text-gold" data-id="element-199" data-mp="20e08oyi1n483">
                        El core
                      </span>}
                  </div>
                </div>
                <p className="mt-4 max-w-xl text-[0.95rem] leading-relaxed text-body sm:text-base" data-id="element-200" data-mp="3jvxw3q19v66k">
                  {pillar.copy}
                </p>
              </div>

              <div className={['w-full min-w-0 overflow-hidden rounded-xl bg-mist p-4 sm:p-5 lg:w-[320px]', pillar.core ? 'lg:w-[380px]' : ''].join(' ')} data-id="element-201" data-mp="3svupg4ylwt7y">
                <PillarVisual visual={pillar.visual} data-id="element-202" data-mp="1p1ei9e0hfq8" />
              </div>
            </article>
          </Reveal>)}
      </ol>
    </div>;
}